import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Notfound from '../pages/notfound/NotfoundPage'
import AppLayout from './../layout/AppLayout'
import Analytics from '../pages/analytics/Analytics'
import Users from '../pages/users/UsersPage'
import Subscriptions from '../pages/subscriptions/SubscriptionsPage'
import { useDispatch, useSelector } from 'react-redux'
import { selectAdminInfo } from '../redux/features/admin/adminSelectors'
import { store, AppDispatch } from '../redux/store/store'
import { fetchAllContentThunk } from '../redux/features/allcontent/allContentState'
import { fetchAudiosThunk } from '../redux/features/audio/audioThunk'
import { fetchBooksThunk } from '../redux/features/books/booksThunk'
import { fetchVideosThunk } from '../redux/features/videos/videoThunk'
import HomePage from '../pages/home/HomePage'
import { VideosPage, AudioPage, BooksPage } from '../pages'
import LoginPage from '../pages/authentication/LoginPage'
import { fetchAllUsersThunk } from '../redux/features/user/userThunk'
import ProtectedRoute from './protectedroute/ProtectedRoute'
import { UsersPage } from '../pages/content/users/UsersPage'
import CommentsPage from '../pages/comments/CommentsPage'

function Navigation() {
  const dispatch = useDispatch<AppDispatch>()

  const adminInfo = useSelector(selectAdminInfo)

  useEffect(() => {
    if (adminInfo) {
      console.log('[Navigation] Fetching initial data...')
      dispatch(fetchAllContentThunk())
      dispatch(fetchAudiosThunk())
      dispatch(fetchBooksThunk())
      dispatch(fetchVideosThunk())
      dispatch(fetchAllUsersThunk())
      console.log('[Navigation] Data fetch dispatched')
    }
  }, [dispatch, adminInfo])

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/users" element={<UsersPage />} />
                  <Route path="/videos" element={<VideosPage />} />
                  <Route path="/audios" element={<AudioPage />} />
                  <Route path="/books" element={<BooksPage />} />
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/subscriptions" element={<Subscriptions />} />
                  <Route path="/comments" element={<CommentsPage />} />
                  <Route path="*" element={<Notfound />} />
                </Routes>
              </AppLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  )
}

export default Navigation
